import { useSelector } from "react-redux";

const useMapViewState = () => {
  const mapViewState = useSelector((state) => state.dashboard.mapViewState);

  const isMapHidden = mapViewState === "hidden";
  const isMapVisible = mapViewState === "map";

  const getModalContainerStyles = (theme) => {
    if (isMapHidden) {
      return {
        position: "absolute",
        top: 0,
        left: 0,
        right: "33.333333%", // Leave space for the instructions panel (4/12 = 1/3)
        bottom: 0,
        borderRadius: 0,
        overflow: "hidden",
        [theme.breakpoints.up("md")]: {
          top: "2%",
          left: "2%",
          right: "35%", // Adjust for instructions panel
          bottom: "2%",
          borderRadius: 24,
        },
        [theme.breakpoints.down("md")]: {
          right: 0, // On mobile, take full width
        },
      };
    }

    // Default full screen when map is visible
    return {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: 0,
      overflow: "hidden",
      [theme.breakpoints.up("md")]: {
        top: "2%",
        left: "2%",
        right: "2%",
        bottom: "2%",
        borderRadius: 24,
      },
    };
  };

  return {
    isMapHidden,
    isMapVisible,
    mapViewState,
    getModalContainerStyles,
  };
};

export default useMapViewState;
